import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/subscriptions/:subscriptionId/settle-installments`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const settleInstallments = {
  post: apiPathFunc(pathBase),
};
